import {
  InMemoryCache,
  Cache,
  Reference,
  InMemoryCacheConfig,
} from '@apollo/client'
import type { CacheIntegrityDebugger } from './CacheIntegrityDebugger'
import { loadCacheIntegrityDebuggerModule } from './CacheIntegrityDebugger.lazy'

const CacheDebugger =
  process.env.NODE_ENV === 'test'
    ? await loadCacheIntegrityDebuggerModule()
    : null

// preload for Cypress tests
if (window.Cypress) loadCacheIntegrityDebuggerModule()

export class DebuggableCache extends InMemoryCache {
  private cacheIntegrityDebugger: CacheIntegrityDebugger | null = null

  constructor(config?: InMemoryCacheConfig) {
    super(config)

    if (CacheDebugger) {
      // For unit tests (which support top level await)
      // we can load the debugger class immediately
      this.cacheIntegrityDebugger = new CacheDebugger(this)
    } else if (window.Cypress) {
      // For Cypress tests we have load debugger class asynchronously
      // as we can't build the app using top level await (Vite do)
      loadCacheIntegrityDebuggerModule().then(
        CacheDebugger => (this.cacheIntegrityDebugger = new CacheDebugger(this))
      )
    }
  }

  write(options: Cache.WriteOptions): Reference | undefined {
    const cacheIntegrityDebugger = this.cacheIntegrityDebugger
    if (!cacheIntegrityDebugger) return super.write(options)

    const { beforeWrite, afterWrite } =
      cacheIntegrityDebugger.getWriteHelpers(options)

    beforeWrite()
    const result = super.write(options)
    afterWrite()

    return result
  }
}
